import { filter, takeUntil } from 'rxjs/operators';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation, Optional, ElementRef, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { LeadTaskService } from 'src/app/services/lead-task.service';
import { LoaderService } from 'src/app/services/loader.service';
import { TwilloDialerComponent } from '../../phone-dialer/twillo-dialer/twillo-dialer.component';
import { environment } from 'src/environments/environment';
import { CreateCampaignTemplateComponent } from '../../whatsappChatModule/create-campaign-template/create-campaign-template.component';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { UserMailConfigService } from 'src/app/services/user-mail-config.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'calsoft-task-popup',
  templateUrl: './task-popup.component.html',
  styleUrls: ['./task-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskPopupComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';


  @Input() task: any;

  // Accept an array of tasks and starting index when opened as a dialog
  @Input() tasks: any[] = [];
  @Input() startIndex: number = 0;

  @Input() type: any = 1;

  @Output() closePopup = new EventEmitter();
  init: boolean = false;
  text: string;
  emailId: any;
  configData: any;
  userName: any;
  userMailConfig: any = 1;
  useIndividualMail: any = 0;
  durarationVisible: boolean = false;

  // WhatsApp properties
  whatsappTemplatePreview: boolean = false;
  whatsappPreviewData: any = null;
  whatsappPreviewBody: string = '';
  whatsappHeaderText: string = '';
  whatsappFooterText: string = '';
  textWhatsApp: string;
  private handleInputJsonCallCount: number = 0;

  callclosepopup() {

    this.dialogRef.close({ event: 'add', })
  }

  close() {

    this.dialogRef.close({ event: 'close', })
  }

  firstFormGroup: UntypedFormGroup;
  showDuration: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private taskService: LeadTaskService,
    private leadActivityService: LeadActivityService,
    private loaderService: LoaderService,
    private dialog: MatDialog,
    private ecryptService: EcryptServiceService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private userMailConfigService: UserMailConfigService,
    @Optional() private dialogRef: MatDialogRef<TaskPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    // If dialog data contains tasks, set them early so ngOnInit can use them
    if (this.dialogData) {
      if (this.dialogData.tasks) this.tasks = this.dialogData.tasks;
      if (this.dialogData.startIndex !== undefined)

        this.startIndex = this.dialogData.startIndex;

      this.task = this.dialogData.tasks[0];
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });

  }

  public serverPath = environment.commonImageApi + 'gmail/';

  ngOnInit(): void {

    this.text = 'Complete';

    console.log("task", this.task);

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        if (data != null) {
          this.useIndividualMail = data['useIndividualMail'];
        }
      } catch (error) {
      }
    }


    this.typeYFilterControl = new UntypedFormControl();
    this.initForm();


    try {
      this.checkAndSetDuration(this.firstFormGroup.get('callOutCome')?.value);
    } catch (e) {

    }

    this.getAllCrmData();

    this.getAllUserMailConfig();
    this.typeYFilter();

    this.text = "Complete";

    this.init = true;

  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      email: [''],
      cc: [''],
      bcc: [''],
      body: [''],
      callPurpose: [''],
      callOutCome: ['No Answer'],
      userName: [''],
      userId: [''],
      type: [''],
      totalEmails: [''],
      title: [''],
      taskId: [''],
      subject: [''],
      stepNotes: [''],
      sequenceId: [''],
      stepId: [''],
      sentCount: [''],
      scheduledDate: [''],
      replyCount: [''],
      priority: [''],
      openedCount: [''],
      message: [''],
      jobTitle: [''],
      intervalDays: [''],
      firstName: [''],
      dueDate: [''],
      clickedCount: [''],
      bouncedCount: [''],
      fromEmail: [''],
      fromEmailId: ['', this.useIndividualMail == 1 ? Validators.required : null],
      toEmail: [''],
      notes: [''],
      prospectEmailid: [''],
      taskStep: [''],
      taskStepPosition: [''],
      sequenceName: [''],
      attachment: [''],
      duration: ['0.0'],
      phoneNumber: [''],
      phoneNo: [''],
      prospectPhoneNumber: [''],
      whatsappTemplateUid: [''],
      whatsappJson: [''],
      leadDetails: [''],
      company: [''],
      leadId: [''],
      attachments: this._formBuilder.array([

      ]),

    });

  }

  // Pagination state
  currentIndex: number = 0;

  nextTask() {
    if (this.tasks && this.currentIndex + 1 < this.tasks.length) {
      this.currentIndex++;
      this.patchTask(this.tasks[this.currentIndex]);
    }
  }

  prevTask() {
    if (this.tasks && this.currentIndex - 1 >= 0) {
      this.currentIndex--;
      this.patchTask(this.tasks[this.currentIndex]);
    }
  }

  goTo(index: number) {
    if (this.tasks && index >= 0 && index < this.tasks.length) {
      this.currentIndex = index;
      this.patchTask(this.tasks[this.currentIndex]);
    }
  }

  patchTask(task: any) {

    const attachmentsFormArray = new UntypedFormArray([]);

    if (task.attachment) {
      task.attachment.split(',')
        .filter(v => v.trim() !== '')
        .forEach(url => {
          const originalName = url.split('/').pop();
          let fileExtension = originalName?.split('.').pop()?.toLowerCase();

          if (fileExtension.includes('&cid=')) {
            fileExtension = fileExtension.split('&cid=')[0];

          }

          attachmentsFormArray.push(
            this._formBuilder.group({
              image: originalName,
              fullUrl: url.trim(),
              fileType: fileExtension
            })
          );
        });
    }

    if (this.useIndividualMail != 1 && !this.userName) {
      const encryptedConfig = localStorage.getItem('configSettingsData');
      if (encryptedConfig) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
          const configData = JSON.parse(decrypted);
          this.userName = configData.smtpUsername;
        } catch (err) { }
      }
    }

    let defaultFromEmailId = '';
    let defaultFromEmail = '';

    if (this.useIndividualMail == 1 && this.dropdownList && this.dropdownList.length > 0) {
      defaultFromEmailId = this.dropdownList[0].userMailConfigId;
      defaultFromEmail = this.dropdownList[0].emailAddress;
    } else if (this.useIndividualMail != 1) {
      defaultFromEmail = this.userName || '';
    }

    let initialFromEmailId = (task.fromEmailId && task.fromEmailId !== 'null' && task.fromEmailId !== 'undefined' && !isNaN(Number(task.fromEmailId)) && Number(task.fromEmailId) !== 0)
      ? Number(task.fromEmailId)
      : (task.fromEmailId && task.fromEmailId !== 'null' && task.fromEmailId !== 'undefined' ? task.fromEmailId : '');

    let initialFromEmail = (task.fromEmail && task.fromEmail !== 'null' && task.fromEmail !== 'undefined') ? task.fromEmail : '';

    if (this.useIndividualMail == 1 && this.dropdownList && this.dropdownList.length > 0) {
      let matchedOpt: any = null;
      if (initialFromEmailId) {
        matchedOpt = this.dropdownList.find(opt => String(opt.userMailConfigId) === String(initialFromEmailId));
      }
      if (!matchedOpt && initialFromEmail) {
        matchedOpt = this.dropdownList.find(opt => opt.emailAddress && opt.emailAddress.trim().toLowerCase() === initialFromEmail.trim().toLowerCase());
      }
      if (matchedOpt) {
        initialFromEmailId = matchedOpt.userMailConfigId;
        initialFromEmail = matchedOpt.emailAddress;
      } else {
        if (!initialFromEmailId) initialFromEmailId = defaultFromEmailId;
        if (!initialFromEmail) initialFromEmail = defaultFromEmail;
      }
    } else if (this.useIndividualMail != 1) {
      if (!initialFromEmail) initialFromEmail = defaultFromEmail;
    }

    this.firstFormGroup = this._formBuilder.group({
      email: task.email,
      cc: task.cc,
      bcc: task.bcc,
      body: task.body,
      callPurpose: task.callPurpose,
      callOutCome: task.callOutCome || 'No Answer',
      userName: task.userName,
      userId: task.userId,
      type: task.type,
      totalEmails: task.totalEmails,
      title: task.title,
      taskId: task.taskId,
      subject: task.subject,
      stepNotes: task.stepNotes,
      sequenceId: task.sequenceId,
      stepId: task.stepId,
      sentCount: task.sentCount,
      scheduledDate: task.scheduledDate,
      replyCount: task.replyCount,
      priority: task.priority,
      openedCount: task.openedCount,
      message: task.message,
      jobTitle: task.jobTitle,
      intervalDays: task.intervalDays,
      firstName: task.firstName,
      dueDate: task.dueDate,
      clickedCount: task.clickedCount,
      bouncedCount: task.bouncedCount,
      toEmail: task.toEmail || task.prospectEmailid || '',
      fromEmail: initialFromEmail,
      fromEmailId: [initialFromEmailId, this.useIndividualMail == 1 ? Validators.required : null],
      notes: task.notes,
      prospectEmailid: task.prospectEmailid || task.toEmail || '',
      taskStep: task.taskStep,
      taskStepPosition: task.taskStepPosition,
      sequenceName: task.sequenceName,
      attachments: attachmentsFormArray,
      attachment: task.attachment,
      duration: task.duration,
      phoneNumber: task.phoneNumber,
      phoneNo: task.phoneNo,
      prospectPhoneNumber: task.prospectPhoneNumber,
      whatsappTemplateUid: task.whatsappTemplateUid,
      whatsappJson: task.whatsappJson,
      company: task.company,
      leadDetails: task.leadDetails,
      leadId: task.leadId
    })


    this.type = task.type || 1;

    if (this.type == 2) {

      task.callOutCome = this.firstFormGroup.value.callOutCome;

      if (task.callOutCome.includes('Connected')) {
        this.durarationVisible = true;

      } else {
        // hide duration for other cases
        this.durarationVisible = false;
      }
    }

    // If WhatsApp task, parse and prepare preview
    if (this.type == 4 || this.type == '4') {
      this.prepareWhatsAppPreview(task);
    }

    // Ensure duration visibility/value is updated when a task is patched
    try {
      this.checkAndSetDuration(this.firstFormGroup.get('callOutCome')?.value);
    } catch (e) {
      // ignore
    }
  }

  ngOnDestroy() {
    // calsoft-doc-editor manages its own teardown
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  callPurpose: any = [
    { value: "Opportunity Call", viewValue: "Opportunity Call" }
  ]

  callOutComeList: any = [
    { value: "No Answer", viewValue: "No Answer" },
    { value: "Left Voicemail", viewValue: "Left Voicemail" },
    { value: "Busy", viewValue: "Busy" },
    { value: "Gatekeeper", viewValue: "Gatekeeper" },
    { value: "Bad / Wrong Number", viewValue: "Bad / Wrong Number" },
    { value: "Not in Service", viewValue: "Not in Service" },
    { value: "Connected - Positive", viewValue: "Connected - Positive" },
    { value: "Connected - Neutral", viewValue: "Connected - Neutral" },
    { value: "Connected - Negative", viewValue: "Connected - Negative" }
  ]



  private checkAndSetDuration(value: any) {
    if (!value) {
      this.showDuration = false;
      return;
    }

    const val = ('' + value).toLowerCase();
    if (val.indexOf('connected') !== -1) {
      this.showDuration = true;
      // set default duration to 0.0 if empty or falsy
      try {
        const control = this.firstFormGroup.get('duration');
        if (control && (control.value === null || control.value === undefined || control.value === '')) {
          control.setValue('0.0');
        }
      } catch (e) { }
    } else {
      this.showDuration = false;
      try {
        const control = this.firstFormGroup.get('duration');
        if (control) control.setValue('0');
      } catch (e) { }
    }
  }

  // Query the child component instance directly (avoids needing a template ref `#campaignTemplate`)
  @ViewChild(CreateCampaignTemplateComponent)
  campaignTemplate!: CreateCampaignTemplateComponent;


  updateTaskStatus() {

    console.log("sa", this.firstFormGroup);


    if (this.firstFormGroup.valid) {


      this.text = "Processing";
      try { this.cdr.detectChanges(); } catch (_) { }

      if (this.firstFormGroup.value.attachments && this.firstFormGroup.value.attachments.length > 0) {
        this.firstFormGroup.value.attachment = this.firstFormGroup.value.attachments
          .map(a => a.fullUrl)
          .filter(url => url)
          .join(',');
      } else {
        this.firstFormGroup.value.attachment = this.firstFormGroup.value.attachment;
      }

      console.log("attactment", this.firstFormGroup.value.attachment);


      delete this.firstFormGroup.value.attachments;

      if (this.type == 4) {

        const phone = this.firstFormGroup.value.phoneNo || this.firstFormGroup.value.phoneNumber;
        if (!phone || !phone.toString().trim()) {
          this.snackBar.open('Cannot complete WhatsApp task: Lead phone number is missing.', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
          this.text = 'Complete';
          try { this.cdr.detectChanges(); } catch (_) { }
          return;
        }

        let object: any = { ...this.firstFormGroup.value };
        if (this.firstFormGroup.value.whatsappJson) {
          try {
            const parsed = typeof this.firstFormGroup.value.whatsappJson === 'string'
              ? JSON.parse(this.firstFormGroup.value.whatsappJson)
              : this.firstFormGroup.value.whatsappJson;
            object.request = parsed;
          } catch (_) { }
        }

        this.updataTaskMethod(object);

      } else {

        if (this.type == 1) {
          const email = this.firstFormGroup.value.prospectEmailid || this.firstFormGroup.value.toEmail;
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!email || !email.toString().trim() || !emailRegex.test(email.toString().trim())) {
            this.snackBar.open('Cannot complete Email task: Lead email is missing or invalid.', '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 3000
            });
            this.text = 'Complete';
            try { this.cdr.detectChanges(); } catch (_) { }
            return;
          }
        } else if (this.type == 2) {
          const phone = this.firstFormGroup.value.phoneNo || this.firstFormGroup.value.phoneNumber;
          if (!phone || !phone.toString().trim()) {
            this.snackBar.open('Cannot complete Call task: Lead phone number is missing.', '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 3000
            });
            this.text = 'Complete';
            try { this.cdr.detectChanges(); } catch (_) { }
            return;
          }
        }

        let object = this.firstFormGroup.value;

        this.updataTaskMethod(object);

      }




    }
    else {
      this.firstFormGroup.markAllAsTouched();

      this.snackBar.open("Form is invalid. Please check all required fields.", '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 3000
      });
    }
  }

  getDueLabel(dateString: string): string {
    if (!dateString) return '';

    const dueDate = new Date(dateString);
    const now = new Date();

    const diffMs = now.getTime() - dueDate.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Due today";
    if (diffDays > 0) {
      if (diffDays < 30) return `Due ${diffDays} days ago`;

      const months = Math.floor(diffDays / 30);
      return `Due ${months} month${months > 1 ? 's' : ''} ago`;
    }

    // future dates
    const futureDays = Math.abs(diffDays);
    if (futureDays < 30) return `Due in ${futureDays} days`;

    const futureMonths = Math.floor(futureDays / 30);
    return `Due in ${futureMonths} month${futureMonths > 1 ? 's' : ''}`;
  }


  showCcBcc: boolean = false;

  toggleCcBcc() {
    this.showCcBcc = !this.showCcBcc;
  }

  phoneNumbercall(data) {

    if (this.webMobileCallEnable == 1) {

      this.leadActivityService.sendWebToMobileCall(data).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });

    } else {

      if (this.dialerType == 1) {
        this.leadActivityService.makeCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          error => {

          });
      }
      else if (this.dialerType == 2) {
        this.opendialCallsa(data)
        this.callANumber1(data, data.phoneNumber)
      }

      else if (this.dialerType == 3) {
        this.loaderService.show();

        let payload = {
          ...data,
          phoneNo: data.phoneNumber,
          phone: data.phoneNumber
        };

        this.leadActivityService.makeDooctiClickToCall(payload).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 5 || this.dialerType == 9) {
        this.loaderService.show();
        this.leadActivityService.makeTelecmi(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 6) {
        this.loaderService.show();
        this.leadActivityService.clickToCallAcefone(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      } else if (this.dialerType == 7) {
        this.callANumberNew(data)
      }


      else if (this.dialerType == 8) {
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            // width: '400px',
            height: 'auto',          // optional
            position: {
              bottom: '2px',        // distance from bottom
              right: '2px'          // distance from right
            },
            disableClose: true,
            data: {
              phone: data.phoneNumber
            }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });

        }
        else {
          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            minWidth: '100vw', height: '100vh',
            data: {
              phone: data.phoneNumber
            }
          });
          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });
        }
      }

      else if (this.dialerType == 10) {
        this.loaderService.show();
        this.leadActivityService.callForBuzzDieal(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }

      else if (this.dialerType == 11) {
        this.loaderService.show();
        this.leadActivityService.calltoElevenlabs(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }

      else {

        this.loaderService.hide();

        let phonenumber;

        if (data.phoneNumber.startsWith("91")) {
          phonenumber = "+" + data.phoneNumber;
        }
        else {
          phonenumber = data.phoneNumber;
        }


        window.location.href = "tel:" + phonenumber;

      }
    }
  }

  dialerType: any;
  webMobileCallEnable: any;
  dialerEnable: boolean = false;
  lastDialedNumber: any;
  encryptPhone: any;
  encryptEmail: any;
  dialerShow: boolean = false;
  data: any;

  @ViewChild('myFrame') myFrame: ElementRef;

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.dialerType = data['dialerType'];
          this.webMobileCallEnable = data['webMobileCallEnable'] == undefined ? 0 : data['webMobileCallEnable'];


          let value = localStorage.getItem(Constant.Sup);

          if (value != undefined) {

            if (value == 'salesUser') {


              this.encryptPhone = data['encryptedPhoneNumber'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.encryptEmail = data['encryptedEmailId'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.userMailConfig = data['useIndividualMail'];

              if (data['useIndividualMail'] != 1) {


                const encryptedConfig = localStorage.getItem('configSettingsData');


                if (encryptedConfig) {

                  try {
                    const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
                    this.configData = JSON.parse(decrypted);

                    this.userName = this.configData.smtpUsername;


                  } catch (err) {
                    console.error("Error decrypting crmSettingsData", err);
                  }
                }

              }

            } else {
              this.encryptPhone = 0;
              this.encryptEmail = 0;
            }

          } else {
            this.encryptPhone = 0;
            this.encryptEmail = 0;
          }


          if (this.dialerType == 7) {
            //   this.initDialer();
          }

          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);


        } else {


        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }

    // If a tasks array is provided, use it for pagination
    if (this.tasks && this.tasks.length > 0) {
      this.currentIndex = Math.max(0, this.startIndex || 0);
      this.patchTask(this.tasks[this.currentIndex]);
    } else if (this.task != null) {
      this.patchTask(this.task);
    }

  }

  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }

  callANumberNew(LeadDetailsObject) {
    const iframeWindow = window.frames['myDialerFrame'] as Window;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }


    let phone = "+" + LeadDetailsObject.phoneNumber.toString();

    const postData = {
      entity_type: "Lead",
      entity_id: LeadDetailsObject.entityId,
      entity_name: LeadDetailsObject.name,
      entity_number: phone,
      user_email: LeadDetailsObject.ownerEmail,
      user_id: LeadDetailsObject.ownerId,
      event_action: "click2call"
    };


    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://app.doocti.com/') {
      return;
    }

    console.log('Received message from iframe:', event.data);
  }

  getResultBanner(event) {

    let cid = localStorage.getItem(Constant.enterPriseKey);

    var arrayControl = this.firstFormGroup.get('attachments') as UntypedFormArray;

    event.productEntityMediaGallery.forEach(element => {

      console.log("fileName", element['fileName']);

      const fileExtension = element['fileName'].split('.').pop()?.toLowerCase();

      console.log("fileExtension", fileExtension);


      let imageFile = this.serverPath + element['fileName'];

      imageFile += "&cid=" + cid;

      arrayControl.push(this._formBuilder.group({
        image: new UntypedFormControl(element['fileName']),
        fullUrl: new UntypedFormControl(imageFile),
        fileType: new UntypedFormControl(fileExtension)
      })

      )
    });

    console.log(this.firstFormGroup);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });

  }

  removeImageOption(index: number): void {
    const imagesFormArray = this.firstFormGroup.get('attachments') as FormArray;
    if (imagesFormArray) {
      imagesFormArray.removeAt(index);
    }
  }

  onCallOutcomeChange(event: any) {
    try {
      const val = event && event.value !== undefined ? event.value : event;

      // Show Duration input when outcome contains 'connected' and activity is a new Phone Call
      if (val.includes('Connected')) {
        this.durarationVisible = true;

      } else {
        // hide duration for other cases
        this.durarationVisible = false;
      }
      // Trigger change detection if needed
      try { this.cdr.detectChanges(); } catch (e) { }
    } catch (e) { /* swallow errors */ }
  }

  // Get Lead Contact Data for Campaign
  getLeadContactData(): any[] {
    const task = this.firstFormGroup.value;
    if (!task) return [];

    console.log('Task data for lead contact:', task);
    console.log('Phone number fields:', {
      phoneNumber: task.phoneNumber,
      phoneNo: task.phoneNo,
      prospectPhoneNumber: task.prospectPhoneNumber,
      phone: task.phone,
      mobile: task.mobile
    });

    // Return lead contact data in the format expected by create-campaign-template
    const leadData = [{
      firstName: task.firstName || '',
      email: task.prospectEmailid || task.toEmail || '',
      phoneNumber: task.phoneNo || task.phoneNumber || task.prospectPhoneNumber || task.phone || task.mobile || ''
    }];

    console.log('Lead contact data prepared:', leadData);
    return leadData;
  }

  // WhatsApp Methods
  prepareWhatsAppPreview(task: any) {
    try {
      if (task.whatsappJson) {
        this.whatsappPreviewData = JSON.parse(task.whatsappJson);

        // If the saved whatsappJson contains an explicit header override (headerVideo/headerImage/headerDocument)
        // apply it into the template `components` so the preview component will render the override media.
        try {
          const dataObj: any = this.whatsappPreviewData;
          const overrideUrl = dataObj?.headerVideo || dataObj?.headerImage || dataObj?.headerDocument;
          let overrideFormat: string | null = null;
          if (dataObj?.headerVideo) overrideFormat = 'VIDEO';
          else if (dataObj?.headerImage) overrideFormat = 'IMAGE';
          else if (dataObj?.headerDocument) overrideFormat = 'DOCUMENT';

          if (overrideUrl && dataObj) {
            if (!dataObj.template) dataObj.template = {};
            if (!Array.isArray(dataObj.template.components)) dataObj.template.components = [];

            let headerComp = dataObj.template.components.find((c: any) => c.type === 'HEADER');
            if (!headerComp) {
              headerComp = { type: 'HEADER', format: overrideFormat, example: { header_handle: [overrideUrl] } };
              dataObj.template.components.unshift(headerComp);
            } else {
              headerComp.format = overrideFormat || headerComp.format;
              if (!headerComp.example) headerComp.example = {};
              headerComp.example.header_handle = [overrideUrl];
            }

            // persist the adjusted JSON back into the form so child preview receives the override
            try {
              if (this.firstFormGroup && this.firstFormGroup.get('whatsappJson')) {
                this.firstFormGroup.patchValue({ whatsappJson: JSON.stringify(dataObj) });
              }
            } catch (e) {
              console.warn('Failed to patch whatsappJson form value with header override', e);
            }

            // ensure local preview object references updated structure
            this.whatsappPreviewData = dataObj;
          }
        } catch (e) {
          console.warn('Error applying whatsapp header override:', e);
        }
        this.whatsappTemplatePreview = true;

        // Store header and footer text
        this.whatsappHeaderText = this.whatsappPreviewData.headerText || '';
        this.whatsappFooterText = this.whatsappPreviewData.footerText || '';

        // Replace variables in body text
        let bodyText = this.whatsappPreviewData.bodyText || '';

        if (this.whatsappPreviewData.variables) {
          Object.keys(this.whatsappPreviewData.variables).forEach((key, index) => {
            const placeholder = `{{${index + 1}}}`;
            const value = this.whatsappPreviewData.variables[key];
            bodyText = bodyText.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), `<strong>${value}</strong>`);
          });
        }

        // Format WhatsApp text (convert *bold* to <strong>, _italic_ to <em>, etc.)
        bodyText = this.formatWhatsAppText(bodyText);

        this.whatsappPreviewBody = bodyText;
      } else {
        this.whatsappTemplatePreview = false;
      }
    } catch (e) {
      console.error('Error parsing WhatsApp template:', e);
      this.whatsappTemplatePreview = false;
    }
  }

  formatWhatsAppText(text: string): string {
    if (!text) return '';

    // WhatsApp formatting:
    // *bold* → <strong>bold</strong>
    text = text.replace(/\*([^\*]+)\*/g, '<strong>$1</strong>');

    // _italic_ → <em>italic</em>
    text = text.replace(/_([^_]+)_/g, '<em>$1</em>');

    // ~strikethrough~ → <s>strikethrough</s>
    text = text.replace(/~([^~]+)~/g, '<s>$1</s>');

    // ```code``` → <code>code</code>
    text = text.replace(/```([^```]+)```/g, '<code>$1</code>');

    // Line breaks
    text = text.replace(/\n/g, '<br>');

    return text;
  }

  //     onCallOutcomeChange(value: any) {
  //   this.checkAndSetDuration(value);
  // }

  handleInputJson(event: any) {
    // Prevent multiple concurrent calls
    if (this.handleInputJsonCallCount > 0) {
      return;
    }

    this.handleInputJsonCallCount++;

    let object = {
      request: event
    }

    let object2 = this.firstFormGroup.value;

    let object1 = { ...object, ...object2 };

    this.updataTaskMethod(object1);
  }

  updataTaskMethod(object) {

    this.textWhatsApp = 'Sent';

    this.taskService.updateTask(object, this.firstFormGroup.value.taskId).subscribe(
      (response) => {


        this.handleInputJsonCallCount = 0;

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.text = "Complete";
          try { this.cdr.detectChanges(); } catch (_) { }
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });


          if (this.tasks.length === 0) {
            this.callclosepopup();
            return;
          }

          if (this.tasks && this.tasks.length > 0) {

            this.tasks.splice(this.currentIndex, 1);

            if (this.tasks.length === 0) {
              this.callclosepopup();
              return;
            }

            else if (this.tasks.length > 0) {

              if (this.currentIndex >= this.tasks.length) {
                this.currentIndex = this.tasks.length - 1;
              }
              this.patchTask(this.tasks[this.currentIndex]);
            } else {

              this.callclosepopup();
            }
          }



        } else {
          this.text = "Complete";
          try { this.cdr.detectChanges(); } catch (_) { }
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.text = "Complete";
        try { this.cdr.detectChanges(); } catch (_) { }
      });
  }

  formFieldInvalid(event: any) {

    this.text = "Complete";

  }


  leadNavigation(leadId) {
    this.callclosepopup();
    this.router.navigate([`leadDetail/${leadId}`])
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  filtereddropdownTypeList: any;
  dropdownTypeList: any;
  dropdownList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllUserMailConfig() {
    this.userMailConfigService.getAllUserMailConfig().subscribe(res => {
      this.dropdownList = res;
      this.dropdownTypeList = res;
      this.filtereddropdownTypeList = this.dropdownTypeList;

      if (this.useIndividualMail == 1 && this.dropdownList && this.dropdownList.length > 0) {
        const currentId = this.firstFormGroup.get('fromEmailId')?.value;
        const currentEmail = this.firstFormGroup.get('fromEmail')?.value || (this.task ? this.task.fromEmail : '');

        let matchedOpt: any = null;
        if (currentId && currentId != 0 && currentId != 'null' && currentId != 'undefined') {
          matchedOpt = this.dropdownList.find(item => String(item.userMailConfigId) === String(currentId));
        }
        if (!matchedOpt && currentEmail && currentEmail != 'null' && currentEmail != 'undefined') {
          matchedOpt = this.dropdownList.find(item => item.emailAddress && item.emailAddress.trim().toLowerCase() === currentEmail.trim().toLowerCase());
        }

        if (matchedOpt) {
          this.firstFormGroup.patchValue({
            fromEmailId: matchedOpt.userMailConfigId,
            fromEmail: matchedOpt.emailAddress,
          });
        } else {
          this.firstFormGroup.patchValue({
            fromEmailId: this.dropdownList[0].userMailConfigId,
            fromEmail: this.dropdownList[0].emailAddress,
          });
        }
      } else {
        const currentId = this.firstFormGroup.get('fromEmailId')?.value;
        if (!currentId || currentId == 'null' || currentId == 'undefined') {
          this.firstFormGroup.patchValue({
            fromEmailId: '',
            fromEmail: this.userName || '',
          });
        }
      }
    },
      error => {
      })
  }

  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }

  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['emailAddress'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }

  onFromEmailChange(userMailConfigId: any) {
    if (!this.dropdownTypeList) {
      return;
    }
    const selected = this.dropdownTypeList.find(opt => String(opt.userMailConfigId) === String(userMailConfigId));
    if (selected) {
      this.firstFormGroup.patchValue({
        fromEmail: selected.emailAddress,
      });
    }
  }

  protected _onDestroy = new Subject<void>();
}
